import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../pages/customerPprofile/UpdatedUi/HomePage.scss";

import { useGetGeoLocationMutation } from "../../Services/vehicle/Vehicle";
import MegaMenu from "../../pages/customerPprofile/UpdatedUi/MegaMenu";

import { toast } from "react-toastify";
import "./customer.scss";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import WorkshopRequestOnboard from "../../pages/vehicle/workshop/WorkshopRequestOnboard";
import axios from "axios";
import { CUST_ID } from "../../constants";
import { useHomePageQuery } from "../../Services/inventory/Inventory";
import { isAutoServicesTenant } from "../../utils/tenantBranding";

const CustomerDrawerContent = ({
    setStoreGeoLocationData,
    setOpenVehicleModal,
    setOpenModal,
    setIsWorkshopSelectorClicked,
    setIsCartOpen,
    vehicleData,
    setCurrentStep,
    homeApiData
}) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [location, setLocation] = useState("");
    const [openWorkshopModal, setOpenWorkshopModal] = useState(false);
    // const [homeApiData, setHomeApiData] = useState<any>({})

    const navigate = useNavigate();

    const [geoLocationTrigger, { status }] = useGetGeoLocationMutation();

    console.log(homeApiData, "fssfefes")



    const storedUser = localStorage.getItem("login-type");
    const userDetails = storedUser ? JSON.parse(storedUser) : null;

    console.log(userDetails, "SDcdscscdscsdc");

    const token = localStorage.getItem("customer-token");
    const fetchingTenant = window.location.hostname.split(".")[0];
    const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
    const apiPort = process.env.REACT_APP_API_PROTOCOL;

    const getLocation = async (e: any) => {
        e.preventDefault();
        const locationPayload = {
            address: location,
        };
        try {
            const response = await geoLocationTrigger(locationPayload);

            setStoreGeoLocationData(response?.data);
            if (response?.data) {
                toast.success("Location fetched successfully");
            } else if (response?.error) {
                toast.error("unabel to find the location");
            }
        } catch (error) {}
    };

    const [clicked, setClicked] = useState("");

    const navArray = [
        ...(token ? [{ label: "Appointment" }, { label: "Profile" }] : []),
        ...(token ? [{ label: "Vehicle" }] : []),
        { label: "Book Online" },

        { label: "Workshop locator" },
        { label: "Our services" },
        { label: "About us" },
        { label: "Contact us" },
        ...(token ? [{ label: "Logout" }] : []),
    ];

    const profileSectionOpener = () => {
        navigate("/customer/profile");
    };

    const navigateHandler = () => {
        navigate("/home");
        // setActiveComponent(false)
    };

    useEffect(() => {
        const shouldOpenCart = localStorage.getItem("openCart");
        if (shouldOpenCart === "true") {
            setIsCartOpen(true);
            localStorage.removeItem("openCart"); // clean up
        }
    }, []);

    const logoutCustomer = async () => {
        try {
            const response = await axios.post(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/customer/logout/`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response?.data) {
                localStorage.removeItem("customer-token");
                localStorage.removeItem("login-type");
                localStorage.removeItem(CUST_ID);
                window.location.replace("/home");
            }
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };

    // useEffect(() => {

    //     HomePageApi()
    // }, [])


    //     const HomePageApi = async () => {
    //     try {
    //         const response = await axios.get(
    //             `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/home/`,
               
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                 },
    //             }
    //         );

    //         if (response?.data) {
    //             setHomeApiData(response?.data)
    //         }
    //     } catch (error) {
    //         console.error("Error fetching profile:", error);
    //     }
    // };

    const navBarHandler = (el) => {
        const token = localStorage.getItem("customer-token");

        if (el?.label === "Appointment") {
            setIsMobileMenuOpen(false);
            navigate("customer/appointments");
        } else if (el?.label === "Our services") {
            setIsMobileMenuOpen(false);
            navigate("customer/services");
        } else if (el?.label === "About us") {
            setIsMobileMenuOpen(false);
            navigate("customer/about-us");
        } else if (el?.label === "Profile") {
            setIsMobileMenuOpen(false);
            navigate("customer/profile");
        } else if (el?.label === "Logout") {
            logoutCustomer();

            // localStorage.clear();
            // window.location.replace('/home');
        } else if (el?.label === "Workshop locator") {
            setIsMobileMenuOpen(false);
            setIsWorkshopSelectorClicked(true);
        } else if (el?.label === "Vehicle") {
            setIsMobileMenuOpen(false);
            navigate("customer/vehicle");
        } else if (el?.label === "Contact us") {
            setIsMobileMenuOpen(false);
            navigate("customer/contact-us");
        } else if (el?.label === "Book Online") {
            if (!token) {
                navigate("/home");
                setIsMobileMenuOpen(false);
                setOpenModal("login");
                return;
            }
            if (token && vehicleData.length === 0) {
                setOpenVehicleModal(true);
                return;
            } else {
                navigate("/vehicle/select");
                setIsMobileMenuOpen(false);
                setCurrentStep(1);
                setIsCartOpen(true);
            }
        } else if (
            el?.label === "Book a Service" ||
            el?.label === "Find a car service"
        ) {
            if (!token) {
                // toast.error("Please login");
                setIsMobileMenuOpen(false);
                setOpenModal("login");
                return;
            }
            localStorage.setItem("openCart", "true"); // set flag
            navigate("/home");
        }
    };

    const vehicleModalhandler = () => {
        if (!token) {
            setOpenModal("login");
            return;
        } else {
            setOpenVehicleModal(true);
        }
    };

    const closeModal = () => {
        setOpenWorkshopModal(false);
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "70%",
        height: "90%",
        overflow: "scroll",
        bgcolor: "background.paper",
        border: "1px solid transparent",
        boxShadow: 2,
        borderRadius: "5px",
        p: 4,
    };

    console.log(homeApiData?.data?.customer?.first_name, "homeApiData?.customer?.first_name")

    return (
        <div className="home-page-cont">
            <div className="home-page-header">
                <div className="top">
                    <div className="left">
                        <span
                            className="img-span"
                            onClick={navigateHandler}
                            style={{ cursor: "pointer" }}
                        >
                          {autoServicesBranding ? (
          <img src="https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg" alt="Auto Services logo" style={{ width: "100%",height:"80px"}} />
        ) : (
          
                            <img
                                src="https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearlogo.png"
                                alt="logo"
                                style={{
                                    width:
                                        window.innerWidth > 800
                                            ? "100%"
                                            : "60%",
                                }}
                            />
        )}
                        </span>
                    </div>
                    {/* <div className="logged-in-name">
                        <span
                            style={{
                                fontFamily: "Karbon-medium",
                                fontSize: "18px",
                            }}
                        >
                            Hi,{" "}
                        </span>
                        <span
                            style={{
                                fontFamily: "Karbon-medium",
                                fontSize: "18px",
                            }}
                        >
                         
{userDetails?.first_name || homeApiData?.customer?.first_name || "Guest"}
                        </span>
                    </div> */}

                    <div className="right-icons-desktop">
                        <div
                            className="desktop-view"
                            style={{
                                display: "flex",
                                gap: "10px",
                                position: "relative",
                            }}
                        >
                            <span
                                style={{
                                    position: "absolute",
                                    marginLeft: "10px",
                                    marginTop: "3px",
                                }}
                            >
                                <i className="bi bi-geo-alt-fill"></i>
                            </span>

                            <input
                                placeholder="Search my Location"
                                className="search-location"
                                onChange={(e) => setLocation(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        getLocation(e); // Trigger click when pressing Enter
                                    }
                                }}
                                type="text"
                                style={{
                                    background: "transparent",
                                    border: "1px solid #C1C1C1",
                                    borderRadius: "30px",
                                    padding: "0 30px",
                                }}
                            />

                            <span
                                onClick={getLocation}
                                style={{
                                    fontSize: "12px",
                                    position: "absolute",
                                    right: "10px",
                                    top: "10px",
                                    cursor: "pointer",
                                }}
                            >
                                <i className="bi bi-search"></i>
                            </span>
                        </div>

                        {token ? (
                            <span
                                onClick={profileSectionOpener}
                                className="desktop-view"
                                style={{
                                    border: "1px solid #D9490C",
                                    color: "#D9490C",
                                    borderRadius: "30px",
                                    padding: "7px 20px",
                                    fontSize: "16px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                Profile
                            </span>
                        ) : (
                            <span
                                onClick={() => setOpenModal("login")}
                                className="desktop-view"
                                style={{
                                    border: "1px solid #D9490C",
                                    color: "#D9490C",
                                    borderRadius: "30px",
                                    padding: "7px 20px",
                                    fontSize: "16px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                Sign In
                            </span>
                        )}

                        {/* <span
                            onClick={() => setOpenModal("cart")}
                            className="desktop-view"
                            style={{
                                border: "1px solid #D9490C",
                                color: "#D9490C",
                                borderRadius: "30px",
                                padding: "7px 20px",
                                fontSize: "16px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                // fontFamily: "Atlassian Sans Ext",
                            }}
                        >
                            Download App
                        </span> */}
                        <span>
                            <div style={{ marginTop: "5px" }}>
                                <i
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add Vehicle"
                                    className="bi bi-car-front-fill"
                                    style={{
                                        fontSize: "20px",
                                        color: "rgb(242, 93, 33)",
                                    }}
                                    onClick={vehicleModalhandler}

                                    // onClick={() => setOpenVehicleModal(true)}
                                ></i>
                            </div>
                        </span>
                    </div>

                    <div className="right-icons-mobile">
                        <div className="mobile-view-headerr">
                            <div className="left-side-home-page">
                                <p className="mobile-menu-toggle">
                                    <i
                                        style={{ fontSize: "20px" }}
                                        className="bi bi-list"
                                        onClick={() =>
                                            setIsMobileMenuOpen(true)
                                        }
                                    ></i>
                                </p>
                                <span className="img-span">
                                    <img
                                        onClick={navigateHandler}
                                        src={
                                            autoServicesBranding
                                                ? "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg"
                                                : "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearlogo.png"
                                        }
                                        alt={autoServicesBranding ? "Auto Services logo" : "EUROREPAR logo"}
                                        style={{ width: "100%", height: autoServicesBranding ? "80px" : undefined }}
                                    />
                                </span>
                            </div>
                            {!token && (
                                <div className="download-app-mobile-icon">
                                    <p
                                        className="app-download"
                                        onClick={() => setOpenModal("login")}
                                    >
                                        {/* <i className="bi bi-geo-alt-fill"></i> */}
                                        <span
                                            style={{
                                                whiteSpace: "nowrap",
                                                width: "100%",
                                                textAlign: "center",
                                            }}
                                        >
                                            Sign in
                                        </span>
                                        {/* <span>
                                        <i className="bi bi-arrow-up-right-circle"></i>
                                    </span> */}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="mobile-view-search">
                            <p style={{ margin: "0" }}>
                                <i className="bi bi-geo-alt-fill"></i>
                            </p>
                            <input
                                placeholder="Search My Location"
                                className="mobile-view-input"
                                onChange={(e) => setLocation(e.target.value)}
                            />
                            <span
                                onClick={getLocation}
                                style={{
                                    fontSize: " 12px",
                                    position: "absolute",
                                    right: " 10px",
                                    top: "10px",
                                    cursor: "pointer",
                                }}
                            >
                                <i className="bi bi-search"></i>
                            </span>
                        </div>
                    </div>
                </div>

                {/* Desktop Nav */}
                <div className="home-page-bottom-cont desktop-only">
                    <MegaMenu
                        setCurrentStep={setCurrentStep}
                        setOpenVehicleModal={setOpenVehicleModal}
                        vehicleData={vehicleData}
                        setOpenModal={setOpenModal}
                        setIsCartOpen={setIsCartOpen}
                        setIsWorkshopSelectorClicked={
                            setIsWorkshopSelectorClicked
                        }
                        setClicked={setClicked}
                        clicked={clicked}
                    />
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="mobile-menu">
                    <div className="mobile-header">
                        <div className="left">
                            <span className="img-span">
                                <img
                                    src={
                                        autoServicesBranding
                                            ? "https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg"
                                            : "https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearlogo.png"
                                    }
                                    alt={autoServicesBranding ? "Auto Services logo" : "EUROREPAR logo"}
                                    style={{ width: "100%", height: autoServicesBranding ? "80px" : undefined }}
                                />
                            </span>
                        </div>
                        <div className="icons">
                            {/* <i className="bi bi-geo-alt-fill"></i> */}
                            <i
                                className="bi bi-x-lg"
                                onClick={() => setIsMobileMenuOpen(false)}
                            ></i>
                        </div>
                    </div>

                    <div className="mobile-nav-list">
                        {navArray?.map((item, i) => (
                            <div
                                key={i}
                                // className={`mobile-nav-item ${
                                //     item.highlight ? "highlight" : ""
                                // }`}

                                className="mobile-nav-item"
                                onClick={() => navBarHandler(item)}
                            >
                                {item.label}
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <Modal
                open={openWorkshopModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                BackdropProps={{
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.2)",
                    },
                }}
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }}
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    ></Typography>

                    <Box>
                        <WorkshopRequestOnboard closeModal={closeModal} />
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default CustomerDrawerContent;